(function () {
  function bindModal(modal) {
    if (modal.dataset.productVideoBound) return;
    modal.dataset.productVideoBound = '1';

    modal.addEventListener('openable-element:open', function () {
      const v = modal.querySelector('video.c-product-video-native');
      if (v) v.play().catch(function () {});
    });
    modal.addEventListener('openable-element:close', function () {
      const v = modal.querySelector('video.c-product-video-native');
      if (v) v.pause();
    });
  }

  function scanRoot(root) {
    if (!root) return;
    root.querySelectorAll('modal-content.c-product-video__modal').forEach(bindModal);
  }

  function designModeCloseStuckModals() {
    if (typeof window.Shopify === 'undefined' || !window.Shopify.designMode) {
      return;
    }
    document.querySelectorAll('modal-content.c-product-video__modal[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      designModeCloseStuckModals();
      scanRoot(document);
    });
  } else {
    designModeCloseStuckModals();
    scanRoot(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    scanRoot(ev.target);
  });
})();
